import axios from '@/api/requests/axios'

export default {
  getClassificatorGroups: (params) => axios.get(`/api/admin/v1/menus/classificator-groups`, { params })
}
